import { GetTaskInfoResponseData } from '@/api';
import { createContext } from 'react';

export interface TaskInfoContextData {
    taskInfo: GetTaskInfoResponseData | null;
    status: 'error' | 'success' | 'pending';
    refetch: () => void;
}

export const TaskInfoContext = createContext<TaskInfoContextData | undefined>(
    undefined
);
